// SubMenu/ui/menuItems/dropdownOptions.ts
import { ReactNode } from 'react';
import cls from './menuItems.module.scss';
import Shock from '@/shared/assets/icons/shock.svg';
import orangeDoc from '@/shared/assets/icons/orangeDoc.svg';
import greenHeart from '@/shared/assets/icons/greenHeart.svg';
import wallet from '@/shared/assets/icons/wallet.svg';
import contacts from '@/shared/assets/icons/contacts.svg';
import products from '@/shared/assets/icons/products.svg';
import bag from '@/shared/assets/icons/bag.svg';
import sberSideBar from '@/shared/assets/icons/sberSideBar.svg';
import online from '@/shared/assets/icons/Online.svg';

export type Option = { label?: string | ReactNode; value?: any; url?: string; logo?: boolean };

export type DropDownItem = {
    options: Option[];
    placeholder: string;
    logo: string;
};
export type DropDownData = DropDownItem[];

export const dropdownData = [
    {
        options: [
            { label: 'Билет в будущее', value: '', url: 'https://sberbank-insurance.ru/policy/bilet_v_budushee' },
            { label: 'Формула жизни', value: '', url: 'https://sberbank-insurance.ru/formula_zhizni' },
            { label: 'ГарантКапитал', value: '', url: 'https://sberbank-insurance.ru/garant_capital' },
            { label: ' Личный приоритет', value: '', url: 'https://sberbank-insurance.ru/policy/lichnyprioritet' },
        ],
        placeholder: 'Накопления',
        logo: Shock,
    },

    {
        options: [{ label: 'Управляемый капитал', value: '', url: 'https://sberbank-insurance.ru/managed-capital' }],
        placeholder: 'Инвестиции',
        logo: orangeDoc,
    },

    {
        options: [
            { label: 'Горизонт здоровья', value: '', url: 'https://sberbank-insurance.ru/gorizontsale/online', logo: true },
            {
                label: 'Ипотечное страхование жизни «Защищенный заемщик»',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/ipoteka_life',
            },
            {
                label: 'Страхование владельцев кредитных карт',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/Credit_card',
            },
            {
                label: 'Страхование заемщиков кредитов "Драйв Клик Банк"',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/setelem',
            },
            {
                label: 'Страхование заемщика потребительского кредита',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/strahovanie_jizni_kredit',
            },
            {
                label: 'Защита жизни, здоровья, потери работы и снижения оклада',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/zashita_life',
            },
        ],
        placeholder: 'Жизнь и здоровье',
        logo: greenHeart,
    },

    {
        options: [
            { label: 'Горизонт здоровья', value: '', url: 'https://sberbank-insurance.ru/gorizontsale/online', logo: true },
            { label: 'Страховка по часам', value: '', url: 'https://sberbank-insurance.ru/strahovka-po-chasam', logo: true },
            { label: ' Личный приоритет', value: '', url: 'https://sberbank-insurance.ru/policy/lichnyprioritet' },
            { label: 'Билет в будущее', value: '', url: 'https://sberbank-insurance.ru/policy/bilet_v_budushee' },
            { label: 'Формула жизни', value: '', url: 'https://sberbank-insurance.ru/formula_zhizni' },
            { label: 'Управляемый капитал', value: '', url: 'https://sberbank-insurance.ru/managed-capital' },
            { label: 'ГарантКапитал', value: '', url: 'https://sberbank-insurance.ru/garant_capital' },
            {
                label: 'Страхование владельцев кредитных карт',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/Credit_card',
            },
            {
                label: 'Страхование заемщиков кредитов "Драйв Клик Банк"',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/setelem',
            },
            {
                label: 'Страхование заемщика потребительского кредита',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/strahovanie_jizni_kredit',
            },
            {
                label: 'Ипотечное страхование жизни «Защищенный заемщик»',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/ipoteka_life',
            },
            {
                label: 'Защита жизни, здоровья, потери работы и снижения оклада',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/zashita_life',
            },
            {
                label: 'Доходный курс плюс (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/dohodnyj_kurs_plus',
            },
            {
                label: 'Детский образовательный план (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/obrazovatelniy_plan',
            },
            {
                label: 'Как зарплата(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/kak_zarplata',
            },
            {
                label: 'Наследие (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/nasledie',
            },
            {
                label: 'Онкострахование детей (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/onko_deti',
            },
            {
                label: 'Онкострахование детей (СберПервый, Sber Private Banking) (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/onko_deti_sb1',
            },
            {
                label: 'Подушка безопасности (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/podushka_bezopasnosti',
            },
            {
                label: 'Первый капитал (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/perviy_kapital',
            },
            {
                label: 'Рантье (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/rante',
            },
            {
                label: 'Смартполис (СберПервый)(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/iszh_perviy',
            },
            {
                label: 'Смартполис (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/invest_programma',
            },
            {
                label: 'Сберкупон. Инвестиции в жизнь (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/iszh_sberkupon_sb1',
            },
            {
                label: 'Семейный актив (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/semeiniy_aktiv',
            },
            {
                label: 'Страхование заемщика потребительского кредита(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/strahovanie_jizni_kredit',
            },
            {
                label: 'Сберполис. Защищенный капитал(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/Sberpolis',
            },
            {
                label: 'Cберегательное страхование (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/sberegatelnoe_strahovanie',
            },
            {
                label: 'Фонд здоровья (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/fondzdorovya',
            },
        ],
        placeholder: 'Все продукты',
        logo: greenHeart,
    },
];
export const dropdownDataMobile = [
    {
        options: [
            { label: 'Билет в будущее', value: '', url: 'https://sberbank-insurance.ru/policy/bilet_v_budushee' },
            { label: 'Формула жизни', value: '', url: 'https://sberbank-insurance.ru/formula_zhizni' },
            { label: 'ГарантКапитал', value: '', url: 'https://sberbank-insurance.ru/garant_capital' },
            { label: ' Личный приоритет', value: '', url: 'https://sberbank-insurance.ru/policy/lichnyprioritet' },
        ],
        placeholder: 'Накопления',
        logo: wallet,
    },

    {
        options: [{ label: 'Управляемый капитал', value: '', url: 'https://sberbank-insurance.ru/managed-capital' }],
        placeholder: 'Инвестиции',
        logo: orangeDoc,
    },

    {
        options: [
            { label: 'Горизонт здоровья', value: '', url: 'https://sberbank-insurance.ru/gorizontsale/online', logo: true },
            {
                label: 'Ипотечное страхование жизни «Защищенный заемщик»',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/ipoteka_life',
            },
            {
                label: 'Страхование владельцев кредитных карт',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/Credit_card',
            },
            {
                label: 'Страхование заемщиков кредитов "Драйв Клик Банк"',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/setelem',
            },
            {
                label: 'Страхование заемщика потребительского кредита',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/strahovanie_jizni_kredit',
            },
            {
                label: 'Защита жизни, здоровья, потери работы и снижения оклада',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/zashita_life',
            },
        ],
        placeholder: 'Жизнь и здоровье',
        logo: greenHeart,
    },

    {
        options: [
            { label: 'Горизонт здоровья', value: '', url: 'https://sberbank-insurance.ru/gorizontsale/online', logo: true },
            { label: 'Страховка по часам', value: '', url: 'https://sberbank-insurance.ru/strahovka-po-chasam', logo: true },
            { label: ' Личный приоритет', value: '', url: 'https://sberbank-insurance.ru/policy/lichnyprioritet' },
            { label: 'Билет в будущее', value: '', url: 'https://sberbank-insurance.ru/policy/bilet_v_budushee' },
            { label: 'Формула жизни', value: '', url: 'https://sberbank-insurance.ru/formula_zhizni' },
            { label: 'Управляемый капитал', value: '', url: 'https://sberbank-insurance.ru/managed-capital' },
            { label: 'ГарантКапитал', value: '', url: 'https://sberbank-insurance.ru/garant_capital' },
            {
                label: 'Страхование владельцев кредитных карт',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/Credit_card',
            },
            {
                label: 'Страхование заемщиков кредитов "Драйв Клик Банк"',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/setelem',
            },
            {
                label: 'Страхование заемщика потребительского кредита',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/strahovanie_jizni_kredit',
            },
            {
                label: 'Ипотечное страхование жизни «Защищенный заемщик»',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/ipoteka_life',
            },
            {
                label: 'Защита жизни, здоровья, потери работы и снижения оклада',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/zashita_life',
            },
            {
                label: 'Доходный курс плюс (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/dohodnyj_kurs_plus',
            },
            {
                label: 'Детский образовательный план (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/obrazovatelniy_plan',
            },
            {
                label: 'Как зарплата(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/kak_zarplata',
            },
            {
                label: 'Наследие (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/nasledie',
            },
            {
                label: 'Онкострахование детей (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/onko_deti',
            },
            {
                label: 'Онкострахование детей (СберПервый, Sber Private Banking) (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/onko_deti_sb1',
            },
            {
                label: 'Подушка безопасности (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/podushka_bezopasnosti',
            },
            {
                label: 'Первый капитал (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/perviy_kapital',
            },
            {
                label: 'Рантье (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/rante',
            },
            {
                label: 'Смартполис (СберПервый)(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/iszh_perviy',
            },
            {
                label: 'Смартполис (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/invest_programma',
            },
            {
                label: 'Сберкупон. Инвестиции в жизнь (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/iszh_sberkupon_sb1',
            },
            {
                label: 'Семейный актив (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/semeiniy_aktiv',
            },
            {
                label: 'Страхование заемщика потребительского кредита(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/strahovanie_jizni_kredit',
            },
            {
                label: 'Сберполис. Защищенный капитал(архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/Sberpolis',
            },
            {
                label: 'Cберегательное страхование (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/sberegatelnoe_strahovanie',
            },
            {
                label: 'Фонд здоровья (архив)',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/fondzdorovya',
            },
        ],
        placeholder: 'Все продукты',
        logo: products,
    },
    {
        options: [
            { label: '900', value: '', url: 'tel:900' },
            {
                label: (
                    <>
                        8 495 500-55-50 <br />
                        <div className={cls.text}>Для звонков по всему миру</div>
                    </>
                ),
                value: '',
                url: 'tel:84955005550 ',
            },
        ],
        placeholder: 'Наши контакты',
        logo: contacts,
    },
];
export const corporativeClients = [
    {
        options: [
            {
                label: 'Коллективное страхование от несчастных случаев и болезней',
                value: '',
                url: 'https://sberbank-insurance.ru/policy/ksinsb',
            },
            { label: 'Второе экспертное медицинское мнение', value: '', url: 'https://sberbank-insurance.ru/policy/smo_corp' },
            { label: 'Чек-ап', value: '', url: 'https://sberbank-insurance.ru/policy/check_ap' },
            { label: 'Лечение особо опасных заболеваний', value: '', url: 'https://sberbank-insurance.ru/policy/ooz_corp' },
            { label: 'Дистанционные медицинские консультации', value: '', url: 'https://sberbank-insurance.ru/policy/dmk_corp' },
        ],
        placeholder: 'Все продукты',
        logo: bag,
    },
];
export const aboutCompany = [
    {
        options: [
            { label: 'О компании', value: '', url: 'https://sberbank-insurance.ru/about' },
            { label: 'История', value: '', url: 'https://sberbank-insurance.ru/about/history' },
            { label: 'Контакты', value: '', url: 'https://sberbank-insurance.ru/about/contacts' },
            { label: 'Новости', value: '', url: 'https://sberbank-insurance.ru/news' },
            { label: 'ESG', value: '', url: 'https://sberbank-insurance.ru/ESG' },
            { label: 'Раскрытие информации', value: '', url: 'https://sberbank-insurance.ru/about/info' },
            { label: 'Финансовые показатели', value: '', url: 'https://sberbank-insurance.ru/about/info#financial_metrics' },
            { label: 'Страховая документация', value: '', url: 'https://sberbank-insurance.ru/about/info#ins_documentation' },
            { label: 'Общие документы', value: '', url: 'https://sberbank-insurance.ru/about/info#policy_actions' },
            { label: 'Закупки', value: '', url: 'https://sberbank-insurance.ru/about/procurement' },
            { label: 'Проверка подписи Страховщика', value: '', url: 'https://sberbank-insurance.ru/check-policy' },
            { label: 'Реестр страховых агентов', value: '', url: 'https://sberbank-insurance.ru/reestr_strahovih_agentov' },
        ],
        placeholder: 'О компании',
        logo: sberSideBar,
    },
];
